<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
    <div v-else>
      <b-row>
        <b-col>
          <component-header
            ref="headerComp"
            title="Tenants"
            @onClickSearch="searchSuggestions"
            :enableOnClickSearch="true"
            @select-query="selectPartnerType"
            :selectedOption="selectedOption"
            :isLoading="loading"
            @reload-data="reloadData"
            @create-press="$router.push({ path: '/tenant/create' })"
            createButtonText="Onboard Tenant"
            :hasCreate="true"
            :hasback="false"
            :hasDropdown="true"
            :hasfilterOptions="searchType"
          />
        </b-col>
      </b-row>
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            style="border-radius: 12px"
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive
            id="my-table"
            :items="tenants"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            thead-class="header"
            class="mt-3"
            :busy="loading"
            show-empty
            :fields="tenantColumns"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="name" slot-scope="data">
              <div class="table-row">{{ data.userName }}</div>
            </template>
            <template slot="action" slot-scope="data">
              <b-button
                size="sm"
                class="button-circle mr-2"
                variant="primary"
                @click="ViewTenant(data.item)"
              >
                <i class="fa fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                class="button-circle mr-2"
                style="background: #fe7b08; border: #fe7b08"
                variant="primary"
                @click="editTenant(data.item)"
              >
                <i class="fa fa-pencil edit"></i>
              </b-button>
            </template>
            <template slot="empty">
              <div v-if="loading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
          </b-table>
        </div>
        <div class="right">
          <b-pagination
            v-if="tenants.length > perPage"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="tenants && tenants.length"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ebButton from "@/components/FormElements/Button";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import ebSelect from "@/components/FormElements/Select.vue";
import { AtomSpinner } from "epic-spinners";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "Tenant",
  components: {
    ebButton,
    VueSimpleSuggest,
    ebSelect,
    ComponentHeader,
    AtomSpinner,
  },
  data() {
    return {
      tenantList: [],
      loading: false,
      selectedType: null,
      selectedOption: "",
      searchType: [
        {
          text: "Select Search Type",
          value: "",
          disabled: true,
        },
        {
          text: "Search by ID",
          value: "id",
        },
        {
          text: "Search by Email",
          value: "email",
        },
        {
          text: "Search by User Name",
          value: "userName",
        },
      ],
      searchText: "",
      filter: "",
      perPage: 10,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      sortBy: "createdAt",
      sortDesc: true,
      fixed: false,
      currentPage: 1,
      loading: true,
      context: "Add",
      tenant: {},
      tenantColumns: [
        {
          key: "_id",
          label: "ID",
          sortable: true,
        },
        {
          key: "userName",
          sortable: true,
        },
        {
          key: "email",
        },
        {
          key: "status",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      allTenantsList: (state) => state.tenant.tenantsList,
    }),
    tenants() {
      let tenantItems = [];
      let data = [...this.allTenantsList];
      if (Array.isArray(data) && data?.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            userName: obj.authentication?.userName || "",
            email: obj.authentication?.email || "",
            phone: obj.authentication?.phone || "",
            password: "",
            status: obj?.status || "",
            ...obj,
          };
          tenantItems.push(arrayObj);
        });
      }
      return tenantItems;
    },
  },
  methods: {
    async searchSuggestions(val) {
      if (!this.selectedOption.length) {
        this.$swal({
          title: "Error",
          text: "Select search by Type!",
          type: "error",
        });
        return;
      }
      if (this.selectedOption == "email") {
        let validMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
        if (!validMail) return;
      }
      try {
        const payload = {
          type: this.selectedOption || "",
          data: val,
        };
        await this.$store.dispatch("tenant/filterListTenant", payload);
      } catch (e) {
        this.$swal({
          title: "Error",
          text: "Select search by Type!",
          type: "error",
        });
      }
    },
    selectPartnerType(val) {
      this.selectedOption = val;
    },
    editTenant(data) {
      this.$router.push({
        name: "editTenant",
        params: { id: data._id, userData: data },
      });
    },
    ViewTenant(data) {
      this.$router.push({
        name: "viewTenant",
        params: { id: data._id, userData: data },
      });
    },
    async deleteTenant(data) {
      this.$swal({
        title: "Delete this Tenant?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch().then((result) => {
            this.$toasted.success("Tenant Deleted Successfully");
            this.$store.dispatch("tenant/fetchTenantsList").catch((error) => {
              this.$toasted.error(error.message);
            });
          });
        }
      });
      this.$store.dispatch(
        "tenant/fetchTenantsList",
        this.$store.getters["auth/getUserID"]
      );
    },
    async reloadData() {
      this.loading = true;
      this.selectedOption = "";
      this.$refs["headerComp"].resetSearchString();
      try {
        await this.$store.dispatch("tenant/fetchTenantsList");
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Faied to fetch data",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("tenant/fetchTenantsList");
    this.loading = false;
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 10px
</style>
<style>
.select-type {
  height: 39px !important;
  padding-top: 5px;
  /* width: 110% !important; */
  /* margin-left: 78px; */
}

.icon-btn {
  border-radius: 50%;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
}

.center {
  margin-left: 36% !important;
  width: 50%;
  padding: 10px;
}

.refresh-button {
  position: absolute;
  font-size: large;
  z-index: 1;
  right: 20px;
  width: 40px;
  height: 35px;
  padding: 0;
  top: 0px;
}

.create-btn {
  height: 36px;
  width: 150px;
  margin-left: 28px;
}

.vue-simple-suggest.designed .input-wrapper input {
  border-radius: 20px !important;
  height: 39px !important;
}

/* 
.form-control {
  height: 39px;
  margin-top: -24px;
} */

.text-grey {
  color: #aaa;
  background-color: transparent;
}

.vue-simple-suggest.designed .input-wrapper input {
  border-radius: 20px !important;
  height: 39px !important;
  /* margin-left: 77px !important; */
  width: 88% !important;
}
.card {
  margin-top: 0px !important;
}
</style>
